define('superAdminMbAnaResDetailsController',[
  'module',
  'underscore',
  'app',
  'bootbox',
  'superAdminMbAnaResDetailsView',
  'emptyView',
  'mbAnaResDetailTabController',
  'rolesMixin',
  'settings',
  'entities/mbanares'
], function(
  module,
  _,
  App,
  bootbox,
  View,
  EmptyView,
  mbAnaResDetailTabController
) {
  'use strict';

  var MbAnaResDetailsController = {
    fetchMbAnaRes: function(data) {
      var that = this,
          emptyView = new EmptyView(),
          contentRegion = App.regions.getRegion('main').currentView.getRegion('content');

      contentRegion.show(emptyView);

      this.data = data;
      if (this.model && this.model.get('secId') === data.secId) {
        this.showMbAnaRes(data);
      } else {
        this.model = App.request('mbanares:model', {secId: data.secId});
        this.model.fetch().done(function() {
          if (contentRegion) {
            that.showMbAnaRes(data);
          }
        });
      }
    },

    showMbAnaRes: function(data) {
      var view = new View({model: this.model, data: data});
      this.view = view;
      data.model = this.model;

      App.regions.getRegion('main').currentView.getRegion('content').show(view);
      this.displayTabs(data);
    },

    displayTabs: function(data) {
      for (var region in this.view.regions) {
        if (App.regions.getRegion('main') && App.regions.getRegion('main').currentView &&
            App.regions.getRegion('main').currentView.getRegion('content') &&
            App.regions.getRegion('main').currentView.getRegion('content').currentView &&
            App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion(region)) {
          var currentViewRegion = App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion(region).currentView;
          if(currentViewRegion) {
            currentViewRegion.destroy();
          }
        }
      }

      if (data.tab) {
        switch (data.tab.name) {          
          default:
            mbAnaResDetailTabController.showTab(data);
            break;
        }
      } else {
        mbAnaResDetailTabController.showTab(data);
      }

      data.model = this.model;
      this.tab = data.tab;
    }    
  };

  module.exports = MbAnaResDetailsController;
});
